export const dateConverter = value => {
	if (!value || value === 'N/A') {
		return 'N/A';
	}

	return (
		new Date(value).getDate().toString().padStart(2, '0') +
		'-' +
		(new Date(value).getMonth() + 1).toString().padStart(2, '0') +
		'-' +
		new Date(value).getFullYear().toString()
	);
};

export function sanitizeTitle(value) {
	const cleaned = value.replace(/[^a-zA-Z0-9_ ]/g, '');
	const withSpaces = cleaned.replace(/_/g, ' ');
	const result =
		withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1).toLowerCase();

	return result;
}

export function cleanText(text) {
	return text
		.replace(/[_/-\s]+/g, ' ')
		.replace(/[^a-zA-Z0-9\s.]/g, ' ')
		.replace(/\s+/g, ' ')
		.trim();
}
